import React from "react";

import Zar8YieldDashboardContent from "../../components/Zar8YieldDashboardContent";
import Header from "../../layouts/Header";

export default function Zar8Dashboard({
  basePath = "/zar8",
  routeFlowType = null,
}) {
  return (
    <div className="min-h-screen bg-[#F8F8F8]">
      <Header />
      <Zar8YieldDashboardContent
        basePath={basePath}
        routeFlowType={routeFlowType}
      />
    </div>
  );
}
